import { Container } from '@mui/material';
import Box from '@mui/material/Box';
import React, { useEffect, useMemo, useState } from 'react';
import { StreamChat } from 'stream-chat';
import { Outlet } from 'react-router-dom';
import CustomAppBar from './CustomAppBar';

const DefaultLayout = () => {
    const [unreadCount, setUnreadCount] = useState<number>(0);
    const API_KEY = process.env.REACT_APP_STREAM_API_KEY as string;

    const client = useMemo(() => StreamChat.getInstance(API_KEY), [API_KEY]);

    useEffect(() => {
        const handler = (event: any) => {
            if (event.unread_channels !== undefined)
                setUnreadCount(event.unread_channels);
            if (event.me && unreadCount === 0)
                setUnreadCount(client.user?.unread_channels as number);
        };
        client.on(handler);
        return () => {
            client.off(handler);
        };
    }, [client, unreadCount]);

    return (
        <Box
            sx={{
                width: '100%',
                minHeight: 'var(--app-viewport-height)',
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                bgcolor: 'background.default',
            }}
        >
            <CustomAppBar />
            <Container maxWidth='xl' sx={{ pt: '130px', flex: 1, minWidth: 0 }}>
                <Outlet />
            </Container>
        </Box>
    );
};

export default DefaultLayout;
